<script>
// types of buttons defined https://www.figma.com/file/aVvlXy2ApVylKLcw6AAXoo/Goalbook-Design-System%3A-Icons-%26-Components?node-id=8234-2154 and https://www.figma.com/file/aVvlXy2ApVylKLcw6AAXoo/Goalbook-Design-System%3A-Icons-%26-Components?node-id=8066-14728
const gbThemes = [
  'bluePrimary',
  'purplePrimary',
  'greenPrimary',
  'redPrimary',
  'grayOutlineSecondary',
  'blueOutlineSecondary',
  'purpleOutlineSecondary',
  'greenOutlineSecondary',
  'redOutlineSecondary',
  'grayFillSecondary',
  'blueFillSecondary',
  'purpleFillSecondary',
  'grayTertiary',
  'blueTertiary',
  'purpleTertiary',
  'greenTertiary',
  'redTertiary',
  'aiPrimary',
  'aiSecondary'
]
export default {}
</script>
<script setup>
import { computed } from 'vue'
import { getCurrentInstance } from 'vue'
import Button from 'primevue/button'
import { TooltipProvider, TooltipTrigger, TooltipContent, TooltipArrow } from 'reka-ui'
import Tooltip from '@/components/tooltip/Tooltip.vue'
defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  tooltipText: {
    type: String,
    required: false,
    default: ''
  },
  tooltipOptions: {
    type: Object,
    required: false,
    default: () => ({})
  },
  ariaDescription: {
    type: String,
    required: false,
    default: ''
  },
  gbTheme: {
    type: String,
    required: false,
    default: 'grayOutlineSecondary',
    validator(value) {
      return gbThemes.indexOf(value) > -1
    }
  },
  iconOnly: {
    type: Boolean,
    required: false,
    default: false
  }
})

const { uid } = getCurrentInstance()

const defaultTooltipOptions = {
  delayDuration: 200,
  contentClass: 'z-50 bg-black text-white p-3 text-sm rounded-xs',
  side: 'top'
}

const tooltipOptions = computed(() => ({
  ...defaultTooltipOptions,
  ...props.tooltipOptions
}))
</script>

<template>
  <TooltipProvider v-if="tooltipText">
    <Tooltip :delay-duration="tooltipOptions?.delayDuration" :side="tooltipOptions?.side" :disable-closing-trigger="tooltipOptions?.disableClosingTrigger">
      <TooltipTrigger as-child>
        <span
          v-if="$attrs.disabled"
          class="inline-block align-middle cursor-not-allowed"
          aria-disabled="true"
          tabindex="0"
          @keydown.enter.prevent
          @keydown.space.prevent
          :aria-describedby="ariaDescription ? `aria-desc-${uid}` : null"
        >
          <span
            v-if="$attrs.disabled && ariaDescription"
            :id="`aria-desc-${uid}`"
            class="sr-only"
          >
            {{ ariaDescription }}
          </span>
          <Button
            v-bind="$attrs"
            :gb-theme="gbTheme"
            :icon-only="iconOnly"
          >
            <slot></slot>
          </Button>
        </span>
        <Button
          v-else
          v-bind="$attrs"
          :gb-theme="gbTheme"
          :icon-only="iconOnly"
        >
          <slot></slot>
        </Button>
      </TooltipTrigger>
      <TooltipContent :class="tooltipOptions?.contentClass" :side="tooltipOptions?.side">
        <p>{{ tooltipText }}</p>
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
  <Button v-else v-bind="$attrs" :gb-theme="gbTheme" :icon-only="iconOnly">
    <slot></slot>
  </Button>
</template>